import { Center } from "@/components/Center/Center";
import { AppleLoginButton } from "@/pages/Auth/components/AppleLoginButton";
import { GoogleLoginButton } from "@/pages/Auth/components/GoogleLoginButton";
import { MiraimaHero } from "@roman/shared/components/Icons/MiraimaHero";
import LoadingSpinner from "@roman/shared/components/LoadingSpinner";
import { isUnknownAuthState, useAuthStore } from "@roman/shared/store/auth.store";
import { getPlatform } from "@roman/shared/utils/platform";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const Login = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const authState = useAuthStore((state) => state.authState);
  const isNewUser = useAuthStore((state) => state.isNewUser);
  const platform = getPlatform();
  const isPC = platform === "pc";
  const [rotation, setRotation] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isRotating, setIsRotating] = useState(false);

  if (isUnknownAuthState(authState)) {
    return (
      <Center>
        <LoadingSpinner />
      </Center>
    );
  }

  if (authState === "authenticated") {
    if (isNewUser) {
      navigate("/register-profile");
    } else {
      navigate(location.state?.from ?? "/");
    }
  }

  return (
    <div className="w-full max-w-[1000px] min-h-[calc(100vh-72px)] flex justify-center mx-auto">
      <div className="flex items-center justify-center">
        <div className="flex flex-col gap-10 w-full px-4 md:px-0 justify-center items-center">
          <div
            className="cursor-pointer"
            style={{
              transform: `rotate(${rotation + (isHovered ? 15 : 0)}deg) scale(${isHovered ? 1.1 : 1})`,
              transition: isRotating ? "transform 800ms ease-out" : "transform 100ms ease-out",
            }}
            onMouseEnter={() => {
              if (isPC) {
                setIsHovered(true);
              }
            }}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => {
              setIsRotating(true);
              setRotation((prev) => prev + 360);
              setTimeout(() => setIsRotating(false), 1000);
            }}
          >
            <MiraimaHero />
          </div>

          <div className="flex flex-col items-center justify-center gap-4">
            <GoogleLoginButton text="Googleでログイン" />
            <AppleLoginButton text="Appleでログイン" />
          </div>
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t backgroundColor-gray" />
            </div>
          </div>
          <h1 className="text-sm text-center text-gray">
            ログインすることで、
            <a href="/terms-of-service" className="text-[#4B57FF] underline">
              利用規約
            </a>
            と
            <a href="privacy-policy" className="text-[#4B57FF] underline">
              プライバシーポリシー
            </a>
            <br />
            に同意したものとみなされます。
          </h1>
        </div>
      </div>
    </div>
  );
};
